import { useEffect, useState, ChangeEvent } from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { Card, CardContent, Stack, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { useQuery, useMutation } from "@apollo/client";
import { GET_PRINTER_NAME, SAVE_PRINTER_NAME } from "../../gql/queries";
import { useShopDetails } from "../../hooks/use-shop";
import { LoadingButton } from "../generic/LoadingButton";

interface PrinterSettingsProps {
	// Empty interface but kept for future props
}

export const PrinterSettings: React.FC<PrinterSettingsProps> = () => {
	const [selectedValue, setSelectedValue] = useState<string>("");
	const { shopId, locationId } = useShopDetails();
	const { data } = useQuery(GET_PRINTER_NAME, {
		variables: { shopId, locationId },
	});
	const [savePrinterName, { loading }] = useMutation(SAVE_PRINTER_NAME);

	const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
		setSelectedValue(event.target.value);
	};

	useEffect(() => {
		const printerName = data?.printerName;
		if (printerName) {
			setSelectedValue(printerName);
		}
	}, [data]);

	const handleSave = async (): Promise<void> => {
		try {
			await savePrinterName({
				variables: { printerName: selectedValue, shopId, locationId },
			});
			localStorage.setItem("printer-name", selectedValue);
			toast.success("Printer name saved");
		} catch (err) {
			console.error('Error saving printer name:', err);
			toast.error('Failed to save printer name');
		}
	};

	return (
		<Card>
			<CardContent>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Typography variant="h6">
							Printer Settings
						</Typography>
						<Stack spacing={2} sx={{ mt: 2 }}>
							<TextField
								fullWidth
								label="Printer Name"
								value={selectedValue}
								onChange={handleChange}
								variant="outlined"
								InputLabelProps={{
									shrink: Boolean(selectedValue),
								}}
							/>
							<LoadingButton
								color="primary"
								loading={loading}
								onClick={handleSave}
								variant="contained"
							>
								Save
							</LoadingButton>
						</Stack>
					</Grid>
				</Grid>
			</CardContent>
		</Card>
	);
};
